import { render, staticRenderFns } from "./document-remove.vue?vue&type=template&id=2076a149&scoped=true"
var script = {}
import style0 from "./document-remove.vue?vue&type=style&index=0&id=2076a149&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2076a149",
  null
  
)

export default component.exports